<template>
  <div class="pr-4 py-2">
    <div class="caption text--secondary">カード名義</div>
    <div class="whitespace-no-wrap">{{payment.holderName}}</div>
  </div>
</template>

<script>
export default {
  name: 'CPaymentDetail',
  props: {
    payment: {
      type: Object,
      required: true
    }
  }
}
</script>
